
(function () {
  document.addEventListener('click', function(event) {
    var modalArrow = event.target.closest('#galModal .trovato-modal-thumb-more-arrow');
    if (!modalArrow) return;

    event.preventDefault();
    event.stopPropagation();

    var wrapper = modalArrow.closest('.thumbnails');
    if (!wrapper) return;

    var track =
      wrapper.querySelector('.modal-thumbs-track-scroller') ||
      wrapper.querySelector('.modal-thumbs-track');

    if (!track) return;

    track.style.overflowY = 'auto';
    track.style.overflowX = 'hidden';
    track.style.maxHeight = '76vh';

    var firstThumb = track.querySelector('.lightbox-thumbnail');
    var scrollAmount = 180;

    if (firstThumb) {
      scrollAmount = Math.round(firstThumb.getBoundingClientRect().height * 1.15);
    }

    track.scrollTop = track.scrollTop + scrollAmount;
  }, true);
})();


(function () {
  var zoomLevel = 1;
  var panX = 0;
  var panY = 0;

  var isDragging = false;
  var hasDragged = false;
  var startX = 0;
  var startY = 0;
  var startPanX = 0;
  var startPanY = 0;

  function getModal() {
    return document.getElementById('galModal');
  }

  function getActiveModalImageSlide() {
    var modal = getModal();
    if (!modal) return null;

    var slides = modal.querySelectorAll('.galSlides.product-media--image');

    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var style = window.getComputedStyle(slide);

      if (style.display !== 'none') {
        return slide;
      }
    }

    return null;
  }

  function getActiveModalImage() {
    var slide = getActiveModalImageSlide();
    if (!slide) return null;
    return slide.querySelector('img');
  }

  function clampPan() {
    var img = getActiveModalImage();

    if (!img || zoomLevel <= 1) {
      panX = 0;
      panY = 0;
      return;
    }

    var maxPanX = Math.max(80, img.offsetWidth * (zoomLevel - 1) * 0.65);
    var maxPanY = Math.max(80, img.offsetHeight * (zoomLevel - 1) * 0.65);

    panX = Math.max(-maxPanX, Math.min(maxPanX, panX));
    panY = Math.max(-maxPanY, Math.min(maxPanY, panY));
  }

  function applyZoom() {
    var modal = getModal();
    if (!modal) return;

    var activeSlide = getActiveModalImageSlide();

    modal.querySelectorAll('.galSlides.product-media--image').forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;

      if (slide === activeSlide) {
        if (zoomLevel > 1) {
          clampPan();
          img.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoomLevel + ')';
          slide.classList.add('trovato-zoomed');
        } else {
          zoomLevel = 1;
          panX = 0;
          panY = 0;
          img.style.transform = 'translate(0px, 0px) scale(1)';
          slide.classList.remove('trovato-zoomed');
        }
      } else {
        img.style.transform = 'translate(0px, 0px) scale(1)';
        slide.classList.remove('trovato-zoomed');
      }
    });
  }

  function resetZoom() {
    zoomLevel = 1;
    panX = 0;
    panY = 0;
    applyZoom();
  }

  function zoomIntoPoint(event) {
    var img = getActiveModalImage();
    var slide = getActiveModalImageSlide();

    if (!img || !slide) return;

    var rect = img.getBoundingClientRect();
    var imageCentreX = rect.left + rect.width / 2;
    var imageCentreY = rect.top + rect.height / 2;

    zoomLevel = 2;

    panX = -(event.clientX - imageCentreX) * (zoomLevel - 1) * 0.85;
    panY = -(event.clientY - imageCentreY) * (zoomLevel - 1) * 0.85;

    applyZoom();
  }

  document.addEventListener('click', function (event) {
    var img = event.target.closest('#galModal .galSlides.product-media--image img');
    if (!img) return;

    if (hasDragged) {
      hasDragged = false;
      return;
    }

    event.preventDefault();

    if (zoomLevel <= 1) {
      zoomIntoPoint(event);
    } else {
      resetZoom();
    }
  });

  document.addEventListener('pointerdown', function (event) {
    var img = event.target.closest('#galModal .galSlides.product-media--image img');
    if (!img || zoomLevel <= 1) return;

    isDragging = true;
    hasDragged = false;
    startX = event.clientX;
    startY = event.clientY;
    startPanX = panX;
    startPanY = panY;

    img.classList.add('trovato-dragging');

    if (img.setPointerCapture) {
      img.setPointerCapture(event.pointerId);
    }
  });

  document.addEventListener('pointermove', function (event) {
    if (!isDragging || zoomLevel <= 1) return;

    var moveX = event.clientX - startX;
    var moveY = event.clientY - startY;

    if (Math.abs(moveX) > 3 || Math.abs(moveY) > 3) {
      hasDragged = true;
    }

    panX = startPanX + moveX;
    panY = startPanY + moveY;

    applyZoom();
  });

  document.addEventListener('pointerup', function (event) {
    if (!isDragging) return;

    var img = getActiveModalImage();

    if (img) {
      img.classList.remove('trovato-dragging');

      if (img.releasePointerCapture) {
        try {
          img.releasePointerCapture(event.pointerId);
        } catch (e) {}
      }
    }

    isDragging = false;
  });

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.lightbox-thumbnail');
    if (!thumb) return;

    setTimeout(function () {
      resetZoom();
    }, 100);
  });
})();


(function () {
  function isTrovatoMobile() {
    return window.matchMedia('(max-width: 949px)').matches;
  }

  function removeTrovatoCylindoControls() {
    document.querySelectorAll('#SlidesCon .media-type-cylindo').forEach(function (slide) {
      slide.classList.remove('trovato-cylindo-active');

      var oldActivate = slide.querySelector('.trovato-cylindo-activate');
      var oldDeactivate = slide.querySelector('.trovato-cylindo-deactivate');
      var oldExpand = slide.querySelector('.trovato-cylindo-expand');

      if (oldActivate) oldActivate.remove();
      if (oldDeactivate) oldDeactivate.remove();
      if (oldExpand) oldExpand.remove();
    });
  }

  function initTrovatoMobileCylindoActivation() {
    if (!isTrovatoMobile()) {
      removeTrovatoCylindoControls();
      return;
    }

    var cylindoSlides = document.querySelectorAll('#SlidesCon .media-type-cylindo');

    cylindoSlides.forEach(function (slide) {
      var oldActivate = slide.querySelector('.trovato-cylindo-activate');
      var oldDeactivate = slide.querySelector('.trovato-cylindo-deactivate');
      var oldExpand = slide.querySelector('.trovato-cylindo-expand');

      if (oldActivate) oldActivate.remove();
      if (oldDeactivate) oldDeactivate.remove();
      if (oldExpand) oldExpand.remove();

      var activateButton = document.createElement('button');
      activateButton.type = 'button';
      activateButton.className = 'trovato-cylindo-activate';
      activateButton.setAttribute('aria-label', 'Activate 360 view');

      activateButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        slide.classList.add('trovato-cylindo-active');
      });

      var deactivateButton = document.createElement('button');
      deactivateButton.type = 'button';
      deactivateButton.className = 'trovato-cylindo-deactivate';
      deactivateButton.textContent = 'Close 360';
      deactivateButton.setAttribute('aria-label', 'Close 360 view');

      deactivateButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        slide.classList.remove('trovato-cylindo-active');
      });

      slide.appendChild(activateButton);
      slide.appendChild(deactivateButton);
    });
  }

  function resetTrovatoCylindoActivation() {
    document.querySelectorAll('#SlidesCon .media-type-cylindo.trovato-cylindo-active').forEach(function (slide) {
      slide.classList.remove('trovato-cylindo-active');
    });
  }

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('.gallery-slider--thumbnail') ||
      event.target.closest('.slider-arrow-left') ||
      event.target.closest('.slider-arrow-right') ||
      event.target.closest('#galModal .close')
    ) {
      resetTrovatoCylindoActivation();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrovatoMobileCylindoActivation);
  } else {
    initTrovatoMobileCylindoActivation();
  }

  window.addEventListener('resize', initTrovatoMobileCylindoActivation);
  document.addEventListener('trovato:gallery-updated', initTrovatoMobileCylindoActivation);
  document.addEventListener('shopify:section:load', initTrovatoMobileCylindoActivation);
})();


(function () {
  document.addEventListener('click', function(event) {
    var normalArrow = event.target.closest('.trovato-thumb-more-arrow');
    if (!normalArrow) return;

    event.preventDefault();
    event.stopPropagation();

    var wrapper = normalArrow.closest('.gallery-slider-thumbnails');
    if (!wrapper) return;

    var track =
      wrapper.querySelector('.gst-scroller') ||
      wrapper.querySelector('.gst-inner');

    if (!track) return;

    track.style.overflowY = 'auto';
    track.style.overflowX = 'hidden';
    track.style.scrollBehavior = 'smooth';

    var firstThumb = track.querySelector('.gallery-slider--thumbnail');
    var scrollAmount = 140;

    if (firstThumb) {
      scrollAmount = Math.round(firstThumb.getBoundingClientRect().height * 1.25);
    }

    track.scrollTop = track.scrollTop + scrollAmount;
  }, true);
})();
